<div fxLayout="column" style="padding:15px;" fxLayoutAlign="center center center">
    <mat-card ngStyle.gt-lg="width:76%;" ngStyle.lg="width:76%;" ngStyle.lt-lg="width:100%;">
        <mat-card-title>
            <app-page-header [title]="pageTitle" action=''></app-page-header>
        </mat-card-title>

        <mat-card-content fxLayout="column">


            <mat-tab-group style="margin-top: 15px;" mat-stretch-tabs fxFlex="grow">

                <mat-tab>
                    <ng-template mat-tab-label>
                        <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                            Βασικές ρυθμίσεις
                        </div>
                    </ng-template>

                    <!--College Image and access info -->
                    <div fxLayout="column" fxFlex="grow" fxLayoutAlign="start start" style="margin-top:50px;">

                        <div fxLayout="row" fxFlex="grow" fxLayoutAlign="start center center" style="width:55%;">
                            <div class="collegeSectionTitle" fxFlex="grow">
                                <u>Λογότυπο Κολλεγίου</u>
                            </div>
                        </div>

                        <!--College Image Section-->
                        <div fxLayout="row" fxLayoutGap="40px" style="height:100px; margin-top:50px;">

                            <div fxLayout="column" fxLayoutAlign="center center center" fxFlex="10"
                                 style="height:100px;">
                                <div style="width:100px; height:100px; border-radius: 50%; border:1px solid lightgray;">
                                    <img *ngIf="imageSource" #imageElement src={{imageSource}} width="100" height="100"
                                         style="border-radius: 50%;" alt=""/>
                                </div>
                            </div>

                            <div fxLayout="column" fxFlex="grow" fxFlexAlign="center" fxLayoutAlign="start"
                                 fxLayoutGap="10px">
                                <div fxLayout="row" fxLayoutAlign="start" class="logoInfo">Ανεβάστε το λογότυπο του
                                    κολλεγίου
                                    σας
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start" class="logoInfo">Η φωτογραφία θα πρέπει να
                                    έχει
                                    μέγιστες διαστάσεις
                                    300px ύψος και 300px πλάτος
                                    <span (click)="removeLogo()"
                                          style="cursor:pointer; margin-left:5px; vertical-align:bottom; color: var(--secondaryBlue); font-size: 12px;">Αφαιρέστε το αποθηκευμένο λογότυπο</span>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start" class="logoInfo" fxLayoutGap="5px">
                                    <button mat-raised-button class="logoButtons"
                                            (click)="!imageSource? fileInput.click() : showRemoveMessage()"
                                            [class.spinner]="imageUploading" [disabled]="imageUploading">
                                        <span>Μεταφόρτωση</span>
                                        <input #fileInput type="file" (change)="onFileInput($event)"
                                               accept="image/png, image/jpeg" style="display:none;"/>
                                    </button>
                                </div>
                            </div>

                        </div>


                        <!--                Basic College Info-->
                        <div fxLayout="row wrap" fxLayoutGap="40px" style="margin-top:50px;">

                            <div fxLayout="column">
                                <div fxLayout="row">Επωνυμία</div>
                                <div fxLayout="row" style="margin-top:5px;">
                                    <mat-form-field appearance="outline" style="width:100%;">
                                        <label>
                                            <input matInput [(ngModel)]="collegeName">
                                        </label>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div fxLayout="column">
                                <div fxLayout="row">Διεύθυνση</div>
                                <div fxLayout="row" style="margin-top:5px;">
                                    <mat-form-field appearance="outline" style="width:100%;">
                                        <label>
                                            <input matInput [(ngModel)]="collegeAddress">
                                        </label>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div fxLayout="column">
                                <div fxLayout="row">Fax</div>
                                <div fxLayout="row" style="margin-top:5px;">
                                    <mat-form-field appearance="outline" style="width:100%;">
                                        <label>
                                            <input matInput [(ngModel)]="collegeFax">
                                        </label>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div fxLayout="column">
                                <div fxLayout="row">Τηλέφωνο</div>
                                <div fxLayout="row" style="margin-top:5px;">
                                    <mat-form-field appearance="outline" style="width:100%;">
                                        <label>
                                            <input matInput [(ngModel)]="collegePhone">
                                        </label>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div fxLayout="column">
                                <div fxLayout="row">Email</div>
                                <div fxLayout="row" style="margin-top:5px;">
                                    <mat-form-field appearance="outline" style="width:100%;">
                                        <label>
                                            <input matInput [(ngModel)]="collegeEmail">
                                        </label>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div fxLayout="column">
                                <div fxLayout="row">Web Site</div>
                                <div fxLayout="row" style="margin-top:5px;">
                                    <mat-form-field appearance="outline" style="width:100%;">
                                        <label>
                                            <input matInput [(ngModel)]="collegeWebSite">
                                        </label>
                                    </mat-form-field>
                                </div>
                            </div>


                            <div fxLayoutAlign="center center center">
                                <button mat-raised-button class="logoButtons" (click)="updateInfo()"
                                        style="color:white; background-color: var(--primary);">Ενημέρωση στοιχείων
                                </button>
                            </div>

                        </div>

                    </div>
                </mat-tab>

                <!--College email sender section-->
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                            Email αποστολέων
                        </div>
                    </ng-template>

                    <div fxLayout="column" fxFlex="grow" fxLayoutAlign="start start" style="margin-top: 50px;">
                        <!--Section Title-->
                        <div fxLayout="row" fxFlex="grow" fxLayoutAlign="start center center">
                            <div class="collegeSectionTitle" fxFlex="grow">
                                <u>Πληροφορίες διεθύνσεων αποστολέων email</u>
                            </div>
                        </div>
                        <!--Section Content-->
                        <div fxLayout="row" fxFlex="100" style="width: 100%;">

                            <div fxLayout="column" fxFlex="100">

                                <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end center center">

                                    <mat-form-field>
                                        <mat-label>Όνομα αποστολέα</mat-label>
                                        <input matInput [(ngModel)]="sender.name">
                                    </mat-form-field>

                                    <mat-form-field>
                                        <mat-label>email αποστολέα</mat-label>
                                        <input matInput [(ngModel)]="sender.address">
                                    </mat-form-field>

                                    <mat-form-field>
                                        <mat-label>Περιγραφή αποστολέα</mat-label>
                                        <input matInput [(ngModel)]="sender.description">
                                    </mat-form-field>

                                    <button *ngIf="!sender.id" mat-icon-button matTooltip="Προσθήκη αποστολέα"
                                            [disabled]="!sender.address || !sender.name || !sender.description"
                                            (click)="addSender()">
                                        <mat-icon>add</mat-icon>
                                    </button>

                                    <button *ngIf="sender.id" mat-icon-button matTooltip="Ενημέρωση αποστολέα"
                                            [disabled]="!sender.address || !sender.name || !sender.description"
                                            (click)="updateSenderInfo()">
                                        <mat-icon>update</mat-icon>
                                    </button>

                                </div>


                                <div fxLayout="row" fxFlex="grow" fxLayoutAlign="center center center">

                                    <div class="mat-elevation-z3" fxLayout="column" style="width: 100%;">

                                        <div fxLayout="row" fxFlex="grow" style="padding: 20px; width: 100%;">
                                            <mat-form-field>
                                                <mat-label>Αναζήτηση αποστολέα</mat-label>
                                                <input matInput (keypress)="searchSenders($event.target.value)">
                                            </mat-form-field>
                                        </div>

                                        <mat-table class="emailTable" matSort [dataSource]="senders"
                                                   style="width: 100%;">

                                            <!-- Position Column -->
                                            <ng-container matColumnDef="id">
                                                <mat-header-cell mat-sort-header fxLayoutAlign="start center center"
                                                                 *matHeaderCellDef> ID
                                                </mat-header-cell>
                                                <mat-cell style='font-family: "Century Gothic", sans-serif;'
                                                          fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.id}} </mat-cell>
                                            </ng-container>

                                            <!-- Name Column -->
                                            <ng-container matColumnDef="address">
                                                <mat-header-cell mat-sort-header fxLayoutAlign="start center center"
                                                                 *matHeaderCellDef>
                                                    Email
                                                </mat-header-cell>
                                                <mat-cell style='font-family: "Century Gothic", sans-serif;'
                                                          fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.address}} </mat-cell>
                                            </ng-container>

                                            <!-- Weight Column -->
                                            <ng-container matColumnDef="name">
                                                <mat-header-cell mat-sort-header fxLayoutAlign="start center center"
                                                                 *matHeaderCellDef>
                                                    Όνομα
                                                </mat-header-cell>
                                                <mat-cell style='font-family: "Century Gothic", sans-serif;'
                                                          fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.name}} </mat-cell>
                                            </ng-container>

                                            <!-- Symbol Column -->
                                            <ng-container matColumnDef="description">
                                                <mat-header-cell mat-sort-header fxLayoutAlign="start center center"
                                                                 *matHeaderCellDef>
                                                    Περιγραφή
                                                </mat-header-cell>
                                                <mat-cell style='font-family: "Century Gothic", sans-serif;'
                                                          fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.description}} </mat-cell>
                                            </ng-container>

                                            <ng-container matColumnDef="action">
                                                <mat-header-cell fxLayoutAlign="center center center" *matHeaderCellDef>
                                                    Ενέργειες
                                                </mat-header-cell>
                                                <mat-cell fxLayoutAlign="center center center"
                                                          *matCellDef="let element">
                                                    <button mat-icon-button style="color:var(--primary);"
                                                            (click)="updateSender(element)">
                                                        <mat-icon>update</mat-icon>
                                                    </button>
                                                    <button mat-icon-button style="color:red;"
                                                            (click)="deleteSender(element);">
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                </mat-cell>
                                            </ng-container>

                                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                                        </mat-table>
                                        <div *ngIf="senders.data.length === 0" fxLayoutAlign="center center center"
                                             style="padding: 15px;">
                                            <label>Δεν υπάρχουν πληροφορίες για τους αποστολείς</label>
                                        </div>
                                        <mat-paginator [length]="senders.data.length" [pageSizeOptions]="[5, 10, 20]"
                                                       showFirstLastButtons></mat-paginator>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </mat-tab>

                <!--College department email-->
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                            Email Τμημάτων
                        </div>
                    </ng-template>

                    <div fxLayout="column" fxFlex="grow" fxLayoutAlign="start start" style="margin-top: 50px;">
                        <!--Section Title-->
                        <div fxLayout="row" fxFlex="grow" fxLayoutAlign="start center center" style="width:55%;">
                            <div class="collegeSectionTitle" fxFlex="grow">
                                <u>Email τμημάτων κολλεγίου</u>
                            </div>
                        </div>

                        <!--Section Content-->
                        <div fxLayout="row" fxFlex="100" style="width: 100%;">

                            <div fxLayout="column" fxFlex="100">

                                <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end center center">
                                    <div fxLayout="column" style="margin-top: 50px;" fxFlex="grow">

                                        <div fxLayout="row" fxLayoutGap="10px" fxFlex="grow"
                                             fxLayoutAlign="end center center">

                                            <mat-form-field>
                                                <mat-label>Όνομα</mat-label>
                                                <input matInput [(ngModel)]="departmentEmail.firstName"/>
                                            </mat-form-field>

                                            <mat-form-field>
                                                <mat-label>Επώνυμο</mat-label>
                                                <input matInput [(ngModel)]="departmentEmail.lastName"/>
                                            </mat-form-field>

                                            <mat-form-field>
                                                <mat-label>Email</mat-label>
                                                <input matInput [(ngModel)]="departmentEmail.email"/>
                                            </mat-form-field>

                                            <mat-form-field>
                                                <mat-label>Τμήμα</mat-label>
                                                <input matInput [(ngModel)]="departmentEmail.department"/>
                                            </mat-form-field>


                                            <button mat-icon-button [disabled]="newMailInvalid()"
                                                    (click)="addNewDepartmentEmail()">
                                                <mat-icon>add</mat-icon>
                                            </button>


                                        </div>

                                        <div fxLayout="row"
                                             style="font-size: 11px; padding-right: 25px; margin-top:10px; margin-bottom: 10px;"
                                             fxLayoutAlign="end center center" fxFlex="grow">
                                            *Δηλώστε τμήμα "Confirmation" για να εισάγετε emails που θα ειδοποιούνται
                                            για την εισαγωγή
                                            χρηστών που χρειάζονται πιστοποίηση
                                        </div>
                                    </div>
                                </div>

                                <div fxLayout="row" fxFlex="grow" fxLayoutAlign="center center center">

                                    <div fxLayout="column" class="mat-elevation-z3" fxLayout="column"
                                         style="width: 100%;">
                                        <mat-table style="width:100% !important;" [dataSource]="departmentEmails">

                                            <!-- Position Column -->
                                            <ng-container matColumnDef="firstName">
                                                <mat-header-cell fxLayoutAlign="start center center" *matHeaderCellDef>
                                                    Όνομα
                                                </mat-header-cell>
                                                <mat-cell fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.firstName}} </mat-cell>
                                            </ng-container>

                                            <ng-container matColumnDef="lastName">
                                                <mat-header-cell fxLayoutAlign="start center center" *matHeaderCellDef>
                                                    Επώνυμο
                                                </mat-header-cell>
                                                <mat-cell fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.lastName}} </mat-cell>
                                            </ng-container>

                                            <ng-container matColumnDef="email">
                                                <mat-header-cell fxLayoutAlign="start center center" *matHeaderCellDef>
                                                    Email
                                                </mat-header-cell>
                                                <mat-cell fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.email}} </mat-cell>
                                            </ng-container>

                                            <ng-container matColumnDef="department">
                                                <mat-header-cell fxLayoutAlign="start center center" *matHeaderCellDef>
                                                    Τμήμα
                                                </mat-header-cell>
                                                <mat-cell fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.department}} </mat-cell>
                                            </ng-container>

                                            <ng-container matColumnDef="symbol">
                                                <mat-header-cell fxLayoutAlign="start center center" *matHeaderCellDef>
                                                    Symbol
                                                </mat-header-cell>
                                                <mat-cell fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.symbol}} </mat-cell>
                                            </ng-container>

                                            <mat-header-row *matHeaderRowDef="displayEmailColumns"></mat-header-row>
                                            <mat-row *matRowDef="let row; columns: displayEmailColumns;"></mat-row>
                                        </mat-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>

                <!--Synchronization settings-->
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                            Συγχρονισμός
                        </div>
                    </ng-template>

                    <div fxLayout="column" fxFlex="grow" fxLayoutAlign="start start" style="margin-top: 50px;">
                        <!--Section Title-->
                        <div fxLayout="row" fxFlex="grow" fxLayoutAlign="start center center" style="width:55%;">
                            <div class="collegeSectionTitle" fxFlex="grow">
                                <u>Διαχείριση συγχρονισμού</u>
                            </div>
                        </div>
                        <!--Section Content-->
                        <div fxLayout="row" fxFlex="100" style="width: 100%; margin-top: 25px;">

                            <div fxLayout="column" fxFlex="100">

                                <div fxLayout="row" fxFlex="grow" fxLayoutAlign="start center center"
                                     fxLayoutGap="10px">

                                    <span>Αντίγραφο ασφαλείας βάσης δεδομένων</span>
                                    <button (click)="databaseBackUp()" [disabled]="socketPending"
                                            [class.spinner]="backupPending"
                                            mat-icon-button>
                                        <mat-icon>source</mat-icon>
                                    </button>

                                    <span>Συγχρονισμός βάσης δεδομένων</span>
                                    <button (click)="simpleSync()" [disabled]="socketPending"
                                            [class.spinner]="syncPending"
                                            mat-icon-button>
                                        <mat-icon>update</mat-icon>
                                    </button>

                                    <span>Προαγωγή τελειοφοίτων σε {{newClass}}</span>
                                    <button (click)="graduateAndSync()" [disabled]="isLoading"
                                            [class.spinner]="isLoading" mat-icon-button>
                                        <mat-icon>upload</mat-icon>
                                    </button>

                                    <span>Εμφάνιση μηνύματος στη λίστα χρηστών</span>
                                    <mat-slide-toggle (change)="showMessageChange()"
                                                      [(ngModel)]="showStudentsMessage"></mat-slide-toggle>


                                </div>

                                <div *ngIf="syncStarted" fxLayout="row" fxFlex="grow" fxLayoutAlign="space-evenly">

                                    <mat-card>
                                        <mat-card-title>Πληροφορίες συγχρονισμού</mat-card-title>
                                        <mat-card-content>
                                            <div fxLayout="row" fxLayoutAlign="start center" style="padding-top: 10px; padding-bottom: 10px;">

                                                <span fxFlex="100">
                                                    {{displayProgressMessage()}}
                                                </span>

                                                <mat-progress-spinner strokeWidth="0.5" diameter="24" *ngIf="syncObject.status === 'pending'" mode="indeterminate"></mat-progress-spinner>
                                                <mat-icon *ngIf="syncObject.status === 'completed'" style="color: green;">done</mat-icon>
                                            </div>
                                        </mat-card-content>
                                    </mat-card>

                                </div>

                                <div fxLayout="row" fxFlex="grow" style="margin-top: 50px;">
                                    <div fxLayout="column" fxFlex="grow">
                                        <mat-table class="emailTable" matSort [dataSource]="syncHistory"
                                                   style="width: 100%;">
                                            <!-- Position Column -->
                                            <ng-container matColumnDef="startedAt">
                                                <mat-header-cell mat-sort-header fxLayoutAlign="start center center"
                                                                 *matHeaderCellDef> Ημ.
                                                    Έναρξης Συγχρονισμού
                                                </mat-header-cell>
                                                <mat-cell style='font-family: "Century Gothic", sans-serif;'
                                                          fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.startedAt}} </mat-cell>
                                            </ng-container>

                                            <!-- Name Column -->
                                            <ng-container matColumnDef="endedAt">
                                                <mat-header-cell mat-sort-header fxLayoutAlign="start center center"
                                                                 *matHeaderCellDef> Ημ.
                                                    Λήξης Συγχρονισμού
                                                </mat-header-cell>
                                                <mat-cell style='font-family: "Century Gothic", sans-serif;'
                                                          fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.endedAt}} </mat-cell>
                                            </ng-container>

                                            <!-- Weight Column -->
                                            <ng-container matColumnDef="duration">
                                                <mat-header-cell mat-sort-header fxLayoutAlign="center center center"
                                                                 *matHeaderCellDef>
                                                    Διάρκεια (δευτερόλεπτα)
                                                </mat-header-cell>
                                                <mat-cell style='font-family: "Century Gothic", sans-serif;'
                                                          fxLayoutAlign="center center center"
                                                          *matCellDef="let element"> {{element.duration}} </mat-cell>
                                            </ng-container>

                                            <!-- Symbol Column -->
                                            <ng-container matColumnDef="sync_display_name">
                                                <mat-header-cell mat-sort-header fxLayoutAlign="start center center"
                                                                 *matHeaderCellDef>
                                                    Εκτελέστηκε από
                                                </mat-header-cell>
                                                <mat-cell style='font-family: "Century Gothic", sans-serif;'
                                                          fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.sync_display_name}} </mat-cell>
                                            </ng-container>

                                            <!-- Symbol Column -->
                                            <ng-container matColumnDef="sync_email">
                                                <mat-header-cell mat-sort-header fxLayoutAlign="start center center"
                                                                 *matHeaderCellDef>
                                                    Email εκτελεστή
                                                </mat-header-cell>
                                                <mat-cell style='font-family: "Century Gothic", sans-serif;'
                                                          fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.sync_email}} </mat-cell>
                                            </ng-container>

                                            <!-- Symbol Column -->
                                            <ng-container matColumnDef="sync_telephone">
                                                <mat-header-cell mat-sort-header fxLayoutAlign="start center center"
                                                                 *matHeaderCellDef>
                                                    Τηλέφωνο εκτελεστή
                                                </mat-header-cell>
                                                <mat-cell style='font-family: "Century Gothic", sans-serif;'
                                                          fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.sync_telephone}} </mat-cell>
                                            </ng-container>


                                            <mat-header-row
                                                    *matHeaderRowDef="displaySyncHistoryColumns"></mat-header-row>
                                            <mat-row
                                                    *matRowDef="let row; columns: displaySyncHistoryColumns;"></mat-row>
                                        </mat-table>

                                        <mat-card *ngIf="syncHistoryLoading">
                                            <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
                                        </mat-card>

                                        <div *ngIf="syncHistory.data.length === 0" fxLayoutAlign="center center center"
                                             style="padding: 15px;">
                                            <label>Δεν υπάρχουν συγχορνισμοί ακόμα</label>
                                        </div>

                                        <mat-paginator #syncPaginator [length]="syncHistory.data.length"
                                                       [pageSizeOptions]="[10, 50, 100]"
                                                       showFirstLastButtons></mat-paginator>
                                    </div>
                                </div>


                            </div>

                        </div>


                    </div>
                </mat-tab>
            </mat-tab-group>

        </mat-card-content>
    </mat-card>

</div>
